import React from "react";
import { ProductCardProps } from "./MProductCard";
import { formatPrice, handleLogin } from "Utils/common";
import { handleContactUs } from "Utils/activityHelper";
interface PriceWidgetProps extends ProductCardProps {
  size?: "small" | "medium" | "large";
}
const MPriceWidget: React.FC<PriceWidgetProps> = (props) => {
  const { product, loginState } = props;
  const {
    listPrice,
    finalPrice,
    priceStatus,
    level1Qty,
    level1Price,
    level2Qty,
    level2Price,
  } = product;

  const priceItems = () => {
    if (priceStatus === "ContactUs") {
      return (
        <div>
          {listPrice && (
            <span
              style={{ paddingRight: "6px" }}
              className="priceItem lightText lineThrough"
            >
              {formatPrice(listPrice) || ""}
            </span>
          )}
          <span className="textLink" onClick={() => {
            handleContactUs(loginState)
          }}>
            联系我们
          </span>
        </div>
      );
    }
    if (priceStatus === "LoginRequired")
      return (
        <div>
          <span className="textLink" onClick={handleLogin}>
            登录可见
          </span>
          {listPrice && (
            <span
              style={{ paddingLeft: "6px" }}
              className="priceItem lightText lineThrough"
            >
              {formatPrice(listPrice) || ""}
            </span>
          )}
        </div>
      );
    if (priceStatus === "Preview")
      return (
        <div className="row">
          <span className="lightText">{formatPrice(finalPrice)}</span>
          {listPrice && (
            <span className="priceItem lightText lineThrough">
              {formatPrice(listPrice) || ""}
            </span>
          )}
        </div>
      );
    return (
      <>
        <div className="row">
          {finalPrice && (
            <span className="primaryText priceItem">
              {formatPrice(finalPrice)}
            </span>
          )}
          {listPrice && (
            <span className="priceItem lightText lineThrough">
              {formatPrice(listPrice) || ""}
            </span>
          )}
        </div>
        <div className="row">
          {level1Qty && level1Price && (
            <span className="lightText priceItem">
              <span>
                {" "}
                {level1Qty}
                {"件"}
              </span>
              <span style={{ paddingLeft: "5px" }}>
                {formatPrice(level1Price)}
              </span>
            </span>
          )}
          {
             (level1Qty && level1Price && level2Qty && level2Price) && <span className="vdivider"></span>
          }
          {level2Qty && level2Price && (
            <span className="priceItem">
              <span className="highlight">
                {level2Qty}
                {"件"}
              </span>
              <span style={{ paddingLeft: "5px" }} className="highlight">
                {formatPrice(level2Price)}
              </span>
            </span>
          )}
        </div>
      </>
    );
  };
  return (
    <div className={`priceWrapper ${props.size || ""}`}>{priceItems()}</div>
  );
};

export default MPriceWidget;
